<!--我的形象-->
<template>
  <div class="my-profile fs18 cr">
    <div class="flex ac jb mb30">
      <p class="bold" :style="{ color: theme.worksColor2 }">我的分身·<span v-if="myVideoArray.length>0">{{myVideoArray.length}}</span>
      </p>
      <div class="flex ac">
        <div class="select-box flex mr30">
          <div class="flex ac jb">
            <div>
              <el-input
                placeholder="名称搜索"
                v-model="selectObj.name"
              >
                <el-button slot="append" icon="el-icon-search" @click="select()"></el-button>
              </el-input>
            </div>
            <div class="dz-btn-box" @click="handleAdd">+定制数字演员</div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="myVideoArray.length<=0" class="no-fenshen-box">
      <img src="../assets/pcImages/4.1_Icon_1@2x.png" alt="no">
      <p>上传视频, 快速复刻数字分身</p>
      <div class="ks-dingzhi cr" @click="handleAdd">+快速定制</div>
    </div>
    <div class="my-works" v-else>
      <div class="flex ac fw">
        <div class="every-video">
          <div class="create-box pl20 pt20">
            <p class="bold" :style="{ color: theme.layout2 }">数字分身</p>
            <p class="fs15" :style="{ color: theme.layout2 }">上传视频, 快速复刻数字分身</p>
            <el-button round icon="el-icon-edit-outline" type="primary"
                       @click="handleAdd">快速复刻
            </el-button>
          </div>
        </div>
        <div class="every-video" @mouseover="handleMouse(item)" @mouseleave="handleMouseOut(item)"
             @click="handlePlay(item)" v-for="(item,index) in myVideoArray" :key="index">
          <div class="img-box" :style="{backgroundImage: 'url(' + item.cover + ')', backgroundRepeat:'no-repeat'}">
          </div>
          <img class="poster-img"
               :src="item.cover"
               alt="">
          <div v-if="hoverId==item.id">
            <div class="jp-btn-box" @click.stop="handleCreate(item)">精品创作</div>
            <img class="bofang-box" src="../assets/images/bofang.png" alt="">
            <div class="close-box" @click.stop="handleDelete(item)">X</div>
          </div>
          <div class="pp-text">{{item.name}}</div>
        </div>
      </div>
    </div>

    <el-dialog
      title=""
      :visible.sync="dialogVisible1"
      :close-on-click-modal="false"
      width="30%"
    >
      <div class="dialog-box">
        <h1 class="tc">上传视频，即刻克隆</h1>
        <h3>使用者承诺须知</h3>
        <ul>
          <li>本声明将帮助您更好的在【欢迎来到{{site_title}}】平台（下称“本平台”）使用相关工具上传和管理您的作品。您若上传作品，即视为您以充分知悉并充分接受以下内容：</li>
          <li>您作为使用者在本平台上传、发布的作品，应具有独立、完整的知识产权，不得侵犯他人知识产权等任何权利。</li>
          <li>
            您在使用本平台及上传、发布作品时，应当自觉遵守国家法律、法规，遵守公共秩序，尊重社会公德、社会主义制度、国家利益、公民合法权益、道德风尚和信息真实性等要求。如有违反，一经本平台发现将根据违规程度采取包括但不限于删除、下架、禁止发布内容、封禁账号等处理方式。如造成恶劣影响或涉嫌违法犯罪的，本平台将有权向有关管理机关或公安机关提交相关内容，并配合进行调查。
          </li>
          <li>
            若您上传的作品及作品中的素材（包括但不限于创意、文本、肖像、音频、图片、视频等）侵犯了任何第三方权利，本平台均有权在收到相关侵权投诉后对该被投诉的作品或用户账号依据相应规则，采取包括但不限于下架、警告、封禁账号等处理方式。
          </li>
        </ul>
        <div class="clone-section">
          <h3>使用规范</h3>
          <div style="font-size: 14px;">您承诺所录制的视频为您本人所有或已获得合法授权，并遵守
<!--            <a style="cursor: pointer" :href="clone_usage" target="_blank" rel="noreferrer">《本平台视频克隆功能使用规范》</a>-->
            <span style="text-decoration:underline ;cursor: pointer" @click="goProtocol">《本平台视频克隆功能使用规范》</span>
          </div>
        </div>

        <div class="flex ac mt20">
          <el-checkbox v-model="checked">我已阅读并同意</el-checkbox>
<!--          <a style="text-decoration:underline ;cursor: pointer" :href="clone_usage" target="_blank" rel="noreferrer">《本平台视频克隆功能使用规范》</a>-->
          <span style="text-decoration:underline ;cursor: pointer" @click="goProtocol">《本平台视频克隆功能使用规范》</span>
        </div>
      </div>

      <span slot="footer" class="tc cr">
        <div class="submit-btn" @click="handleSumbit">我已知晓，同意</div>
      </span>
    </el-dialog>

    <el-dialog
      title="复刻数字分身"
      :visible.sync="dialogVisible2"
      width="50%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="">
        <p class="pp3"><span style="color: red">*</span> 数字分身名称</p>
        <el-input
          placeholder="请输入数字分身名称"
          v-model="videoUpName">
        </el-input>
        <p class="pp3"><span style="color: red">*</span> 视频参数</p>
        <div class="voice-yq">
          <div class="pp2">视频要求</div>

          <ul class="ul-box">
            <li>视频方向：横向或纵向</li>
            <li>文件格式：mov、mp4</li>
            <li>视频时长：5秒～30分钟</li>
            <li>分辨率：360k~4K</li>
            <li>文件大小：小于500MB</li>

          </ul>
        </div>
        <div class="upload-box mt20" v-if="fileList.length<=0">
          <el-upload
            v-if="progressStatus==''"
            ref="upload"
            drag
            :action="uploadUrl"
            accept=".mp4,.mov,.MP4,.MOV"
            :on-progress="handleUping"
            :on-success="handleFileUpSuccess"
            :on-error="handleFileUpError"
            :on-remove="handleRemove"
            :before-upload="beforeAvatarUpload"
            multiple
            :limit="1"
            :headers="myHeaders"
            :data="needParam"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">请上传一段视频，用于分身克隆(关闭HDR录制的视频文件)</div>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          </el-upload>
          <div class="progress-box" v-if="progressStatus=='active'">
            <p class="fs20 tc">{{Math.round(progressPercentage)}}%</p>
            <el-progress :percentage="progressPercentage" :stroke-width="12" :show-text="false"></el-progress>
            <p class="tc">视频上传中...</p>
          </div>

        </div>
        <div class="upload-box mt20" style="height: 380px" v-else>
          <video ref="videoPlayer1" style="width: 100%;height: 100%" controls="" :autoplay="false"
                 :src="fileList[0].url"></video>
          <div class="flex ac jc">
            <el-button type="warning" size="mini" style="margin:10px 0 50px 0" @click="handleReUplod">重新上传</el-button>
          </div>
        </div>

      </div>
      <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible2 = false">取 消</el-button>
    <el-button type="primary" @click="handleStartClone2" :disabled="buttonLoading">开始克隆</el-button>
  </span>
    </el-dialog>

    <el-dialog
      :title="videoName"
      :visible.sync="dialogVisible3"
      width="50%"
      @close="handleDialogClose"
    >
      <div class="dialog-video">
        <video ref="videoPlayer" style="width: 100%;height: 100%" controls="" autoplay="" :src="videoUrl"></video>
      </div>
      <span slot="footer" class="tc cr">
        <div class="jp-btn-box2" @click="handleJump()">精品创作</div>
      </span>
    </el-dialog>


  </div>
</template>
<script>
  import {getVideo, postVideo, delVideo, uploadSign, uploadComplete} from '../api/user'
  import {throttle} from '../../utils/index'


  export default {
    name: '',
    data() {
      return {
        dialogVisible3: false,
        autoState: true,
        myVideoArray: [],
        ggVideoArray: [],
        selectObj: {
          page: 1, limit: 9999, name: ''
        },
        hoverId: '',
        videoId: '',
        videoName: '',
        videoUrl: '',
        fileList: [],
        loading: '',
        videoUpName: '',
        editId: '',
        dialogVisible1: false,
        dialogVisible2: false,
        checked: true,
        needParam: {},
        uploadUrl: '',
        uploadDir: '',
        uploadSize: '',
        duration: 0,
        progressPercentage: 0, // 进度条的百分比
        progressStatus: '',
        site_title: '',
        clone_usage: '',
        buttonLoading: false
      }
    },
    computed: {
      myHeaders() {
        return {'x-token': window.localStorage.getItem('xcToken') || ''}
      },
      theme() {
        return this.$store.getters.getTheme;
      }
    },
    created() {
      if (window.localStorage.getItem('siteJson')) {
        const siteJson = JSON.parse(window.localStorage.getItem('siteJson'))
        this.site_title = siteJson.siteTitle
        this.clone_usage = siteJson.cloneUsage
      }
      this.getMyVideoList()
      this.getggVideoList()
      this.getUploadSign()
    },
    methods: {
      getMyVideoList() {
        getVideo({source: '1', ...this.selectObj}).then(res => {
          this.myVideoArray = res.data.list
        })
      },
      getggVideoList() {
        getVideo({source: '2', ...this.selectObj}).then(res => {
          this.ggVideoArray = res.data.list
        })
      },
      getUploadSign() {
        uploadSign({file_type: 'video'}).then(res => {
          this.uploadUrl = res.data.host
          this.uploadDir = res.data.dir
          this.needParam = {
            'OSSAccessKeyId': res.data.access_key_id,
            'policy': res.data.policy,
            'signature': res.data.signature,
          }
        })
      },
      handleCreate(item) {
        this.$router.push({
          path: '/create',
          query: {
            id: item.id
          }
        })
      },
      handleJump() {
        this.$router.push({
          path: '/create',
          query: {
            id: this.videoId
          }
        })
      },
      handleAdd() {
        this.dialogVisible1 = true
        this.editId = ''
        this.videoUpName = ''
      },
      handleSumbit() {
        if (this.checked) {
          this.fileList = []
          this.videoUpName = ''
          this.dialogVisible1 = false
          this.dialogVisible2 = true
        } else {
          this.$message.error('请阅读并同意《本平台音色克隆使用规范》')
        }
      },
      handleReUplod() {
        this.fileList = []
        // 重置上传组件
        this.$refs.upload && this.$refs.upload.clearFiles();
        this.videoUpName = ''
      },
      // 节流函数
      throttle(func, limit) {
        let inThrottle;
        return function(...args) {
          const context = this;
          if (!inThrottle) {
            func.apply(context, args);
            inThrottle = true;
            setTimeout(() => (inThrottle = false), limit);
          }
        };
      },

      // handleStartClone2() {
      //
      // },

      handleStartClone2: throttle(function() {
        this.handleStartClone();
      }, 1000),

      handleStartClone() {
        if (!this.videoUpName) {
          this.$message.error('请给您创建的视频起一个名称')
          return false
        } else if (this.fileList.length <= 0) {
          this.$message.error('请上传视频')
          return false
        } else {
          this.buttonLoading = true
          postVideo({name: this.videoUpName, file_id: this.fileList[0].file_id}).then(() => {
            this.fileList = []
            // 重置上传组件
            // this.$refs.upload.clearFiles();
            this.videoUpName = ''
            this.$message.success('克隆成功')
            this.getMyVideoList()
            this.loading.close();
          }).catch(error => {
            this.loading.close();
            this.$message.error(error.msg)
          })
          this.buttonLoading = false
          this.dialogVisible2 = false
        }
      },
      select() {
        this.getMyVideoList()
      },
      handleMouse(item) {
        this.hoverId = item.id
      },
      handleMouseOut() {
        this.hoverId = ''
      },
      handlePlay(item) {
        this.videoName = item.name
        this.videoUrl = item.url
        this.videoId = item.id
        this.dialogVisible3 = true
      },
      handleDialogClose() {
        // 停止视频播放
        if (this.$refs.videoPlayer) {
          this.$refs.videoPlayer.pause();
        }
        // 重置视频源
        // this.videoSrc = '';
      },
      beforeAvatarUpload(file) {
        var file_type = file.name.split('.').slice(-1)
        const isLt500M = file.size / 1024 / 1024 < 500
        const fileExtension = file.name.split('.').pop().toLowerCase()
        if (fileExtension != 'mp4' && fileExtension != 'mov' || !isLt500M) {
          this.$message.error('请上传500M以内的MP4/MOV格式的视频')
          return false
        } else {
          var file_name = this.uploadDir + Date.parse(new Date()) + '' + parseInt(Math
            .random() * 100) + '.' + file_type
          this.needParam.key = file_name
          this.uploadSize = file.size
        }

        // if (fileExtension == 'mp4' || fileExtension == 'mov') {
        //   return true
        // } else {
        //   this.$message.error('请上传MP4/MOV格式的视频')
        //   return false
        // }
        // if (isLt500M) {
        //   return true
        // } else {
        //   this.$message.error('视频大小应该低于 500M')
        //   return false
        // }
      },

      handleRemove() {
        this.fileList = []
      },
      handleUping(event) {
        this.loading = this.$loading({
          lock: true,
          text: '',
          spinner: 'none',
          background: 'rgba(0, 0, 0, 0.6)'
        });
        this.progressStatus = 'active';
        this.progressPercentage = event.percent;
        if (event.percent === 100) {
          this.progressStatus = 'success';
          setTimeout(() => {
            this.progressPercentage = 0;
            this.progressStatus = '';
          }, 300);
        }
      },

      handleFileUpSuccess(file) {
        const url = `${this.uploadUrl}/${this.needParam.key}`
        // 获取时长
        var video = document.createElement('video');
        video.src = url;
        const that = this
        video.addEventListener('loadedmetadata', function () {
          uploadComplete({file_type: 'video', size: that.uploadSize, duration: video.duration, url: url}).then(res => {
            if (res.data.url && res.data.file_id) {
              that.fileList.push(res.data)
              that.$message.success('上传成功')
              that.loading.close();
            }
          }).catch(() => {
            that.loading.close();
            that.fileList = []
            // 重置上传组件
            that.$refs.upload.clearFiles();
          })
        });
      },

      // handleFileUpSuccess(file) {
      //   if (file.data.url && file.data.file_id) {
      //     postVideo({ name: this.videoUpName, file_id: file.data.file_id }).then(() => {
      //       this.fileList = []
      //       // 重置上传组件
      //       this.$refs.upload.clearFiles();
      //       this.videoUpName = ''
      //       this.$message.success('上传成功')
      //       this.getMyVideoList()
      //       this.loading.close();
      //     }).catch(error => {
      //       this.loading.close();
      //       this.$message.error(error.msg)
      //     })
      //   }
      // },
      handleFileUpError() {
        this.$message.error('上传失败，请重新上传')
        this.loading.close();
      },
      goProtocol() {
        const routeData = this.$router.resolve({
          path: '/protocol',
          query: {
            type: 'clone'
          }
        });
        window.open(routeData.href, '_blank');
      },
      handleDelete(item) {
        this.$confirm('此操作将永久删除该分身, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delVideo({id: item.id}).then(() => {
            this.$message.success('删除成功')
            this.getMyVideoList()
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      }
    },
    /**加载完组件时执行(加载完成之后执行)*/
    mounted() {
    },
  }
</script>

<style lang="scss" scoped>
  .my-profile::-webkit-scrollbar {
    display: none !important;
    width: 0 !important;
    height: 0 !important;
  }
  .my-profile {
    /*background-color: #0D1027;*/
    width: 100%;
    height: calc(100vh - 50px);
    overflow-y: scroll;
    overflow-x: hidden;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* Internet Explorer 10+ */
    padding: 33px 40px;
  }

  .dz-btn-box {
    width: 144px;
    height: 40px;
    background: #6C14FF;
    border-radius: 6px;

    font-weight: 500;
    font-size: 14px;
    color: #FFFFFF;
    line-height: 40px;
    text-align: center;
    margin-left: 15px;
  }

  .no-fenshen-box {
    margin-top: 40vh;

    img {
      width: 48px;
      height: 48px;
    }

    font-weight: 400;
    font-size: 16px;
    color: #FAFAFA;
    text-align: center;

    .ks-dingzhi {
      width: 156px;
      height: 48px;
      background: linear-gradient(312deg, #6C14FF 0%, #01FBF5 100%);
      border-radius: 6px;

      font-weight: 600;
      font-size: 16px;
      color: #FFFFFF;
      line-height: 48px;
      text-align: center;
      margin: 0 auto;
    }
  }

  .my-works {
    .select-box {
      padding: 20px 0;
      height: 80px;
      width: 100%;
      position: sticky;
      top: 0;
      z-index: 999;
      background: #fff;
    }

    .every-video {
      width: 280px;
      height: 250px;
      border-bottom-right-radius: 8px;
      border-bottom-left-radius: 8px;
      position: relative;
      cursor: pointer;
      margin: 0 25px 25px 0;
      background-size: 100% 100%;

      .create-box {
        width: 100%;
        height: 200px;
        border: 0.5px #409EFF dashed;
        border-radius: 8px;

      }

      .img-box {
        position: absolute;
        z-index: 0;
        top: 0;
        left: 0;
        width: 100%;
        height: 200px;
        background: rgba(0, 0, 0, .3);
        background-position: center center;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        filter: brightness(.5);
        transform-origin: center center;
        object-fit: cover;
        position: relative;
        border-radius: 8px;
      }

      .poster-img {
        width: 50%;
        height: 200px;
        position: absolute;
        left: 25%;
        top: 0;
        z-index: 999;
        object-fit: cover;
      }

      .pp-text {
        font-size: 13px;
        padding: 0 5px;
        margin-top: 8px;
        overflow: hidden;
        width: 100%;
        height: 30px;
        text-overflow: ellipsis;
        white-space: nowrap;
        line-height: 32px;
        flex: 1;
      }

      .jp-btn-box {
        background: linear-gradient(to right, #000000, #512D7A);
        width: 76px;
        height: 30px;
        font-size: 12px;
        color: #fff;
        border-width: 0;
        border-radius: 4px;
        box-shadow: #40558029 0 4px 12px;
        font-weight: 600;
        line-height: 30px;
        text-align: center;
        position: absolute;
        right: 5px;
        bottom: 15px;
      }

      .bofang-box {
        position: absolute;
        top: 32%;
        left: 45%;
        width: 40px;
        height: 40px;
        z-index: 99999;
      }

      .close-box {
        position: absolute;
        top: 5px;
        right: 5px;
        width: 30px;
        height: 30px;
        background: #ffffff;
        color: black;
        line-height: 30px;
        z-index: 99999;
        text-align: center;
        border-radius: 3px;
      }

    }

    .every-video:hover {
      transform: scale(1.01);
      box-shadow: 0 4px 12px #434344;
      transition: transform .3s ease 0s, box-shadow .3s ease 0s;
    }
  }

  .dialog-video {
    width: 100%;
    height: 440px;
  }

  .jp-btn-box2 {
    background: linear-gradient(to right, #000000, #512D7A);
    width: 76px;
    height: 30px;
    font-size: 12px;
    color: #fff;
    border-width: 0;
    border-radius: 4px;
    box-shadow: #40558029 0 4px 12px;
    font-weight: 600;
    line-height: 30px;
    text-align: center;
    margin: 0 auto;
  }

  .submit-btn {
    margin: 30px 0;
    background: #635cf6 !important;
    width: 100%;
    display: inline-block;
    vertical-align: middle;
    height: 38px;
    line-height: 38px;
    border: 1px solid transparent;
    padding: 0 18px;
    color: #fff;
    white-space: nowrap;
    text-align: center;
    font-size: 14px;
    border-radius: 2px;
    cursor: pointer;
  }

  .pp3 {
    font-size: 14px;
    color: #091221;
    line-height: 22px;
    font-weight: 500;
    margin: 15px 0 !important;
  }

  .voice-yq {
    background: #f3f4fb;
    padding: 16px;
    border-radius: 6px;

    .ul-box {
      line-height: 25px;
      display: grid;
      display: grid;
      grid-template-columns: repeat(3, 1fr);
    }

  }

  .progress-box {
    background-color: #fff;
    border: 1px dashed #d9d9d9;
    border-radius: 8px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 100%;
    height: 200px;
    text-align: center;
    cursor: pointer;
    overflow: hidden;
    padding: 40px 15px 0;
  }

</style>
<style>
  .my-works .el-input {
    width: 200px !important;
  }

  .my-profile .el-dialog__body {
    padding: 0 30px !important;
  }

  .upload-box .el-upload {
    width: 100%;
  }

  .upload-box .el-upload .el-upload-dragger {
    width: 100% !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/profile.vue